import React from 'react';
import PropTypes from 'prop-types';
import { Sessions } from '@ramsey-plus-components/group-coaching';

const GroupCoaching = (props) => {
  const { baseUri, firstName, lastName, email, path } = props;

  return (
    <Sessions
      baseUri={baseUri}
      path={path}
      firstName={firstName}
      lastName={lastName}
      email={email}
    />
  );
};

GroupCoaching.propTypes = {
  baseUri: PropTypes.string.isRequired,
  path: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string
};

export default GroupCoaching;
